import intersection from 'lodash/intersection'

export default {
  data: function () {
    return {
      updating: false,
      authenticated: false,
      user: null
    }
  },

  methods: {
    getUser: async function () {
      try {
        const response = await this.$http.get('/api/myself')
        this.authenticated = true
        this.user = response.data
      } catch (e) {
        console.error('Fetch user error', e.message)
        this.authenticated = false
        this.user = null
      }
    },
    updateUser: async function (data) {
      try {
        this.updating = true
        const response = await this.$http.put('/api/myself', data)
        this.user = response.data
      } catch (e) {
        throw e
      } finally {
        setTimeout(() => { this.updating = false}, 250)
      }
    },
    logout: async function () {
      try {
        await this.$http.get('/api/logout')

        location.reload()
      } catch (e) {
        console.error('Logout error', e.message)
      }
    },
    hasAnyOfRoles: function (roles) {
      return this.authenticated && (intersection(this.user.roles, roles).length > 0)
    },
    authenticate: async function (username, password) {
      try {
        await this.$http.post('/api/auth', { username: username, password: password })
        this.authenticated = true
        return true
      } catch (e) {
        console.error('Auth error', e.message)
        this.authenticated = false
        this.user = null
        throw new Error(e.response.data.message)
      }
    }
  },

  /**
   *
   * @param Vue
   * @param opts
   * @param opts.router
   */
  install: function (Vue, opts) {
    if (!Vue.axios) {
      throw Error('vue-axios is a required')
    }
    let http = Vue.axios

    if (!opts.router) {
      throw Error('vue-router passed in opts.router is a required')
    }
    let router = opts.router

    const _this = this

    const self = new Vue(_this)

    Object.defineProperty(Vue.prototype, '$auth', {
      get () {
        return self
      }
    })

    http.interceptors.response.use(response => response, error => {
      const status = error && error.response && error.response.status
      if (status === 401) {
        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }
      }
      return Promise.reject(error)
    })

    router.beforeEach(async (to, from, next) => {
      if (to.path !== '/login' && to.name !== 'PasswordReset' && to.name !== 'PasswordResetConfirm') {
        await self.getUser()
      }

      if (!self.authenticated) {
        if (to.path === '/login' || to.name === 'PasswordReset' || to.name === 'PasswordResetConfirm') {
          next()
        } else {
          next('/login')
        }
      } else {
        if (to.path === '/login' || to.name === 'PasswordReset' || to.name === 'PasswordResetConfirm') {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    })
  },

  computed: {}
}
